/**
 * Field names as the drawer says them (25.09.2026).
 *
 * The dossier fills in what the enrolment never had, and reports what it
 * disagrees with rather than overwriting it. The report names fields, so the
 * names have to read as Romanian rather than as database columns.
 */
export const FIELD_LABEL = {
  nume: "numele",
  initiala_tatalui: "inițiala tatălui",
  prenume: "prenumele",
  cnp: "CNP-ul",
  functie_didactica: "funcția didactică",
  specializare: "specializarea",
  unitate: "unitatea de învățământ",
  city: "localitatea",
  county: "județul",
};

/** "Datele din dosar diferă de fișă la: județul și unitatea de învățământ." */
export function differsNote(fields = []) {
  const names = (fields || []).map((f) => FIELD_LABEL[f] || f);
  if (names.length === 0) return "";
  const list = names.length === 1
    ? names[0]
    : `${names.slice(0, -1).join(", ")} și ${names[names.length - 1]}`;
  return `Datele din dosar diferă de cele din fișa înscrierii la: ${list}. `
    + "Fișa a rămas neschimbată — dosarul e cel cerut pentru curs, deci verifică ce e corect.";
}

/**
 * A change waiting to be checked, as rows a person can compare (19.10.2026):
 * the field in words, what is stored, what was sent. The CNP comes masked
 * from the server unless somebody asked to see it.
 */
export function changeRows(change) {
  return Object.entries(change?.diff || {}).map(([field, v]) => ({
    field,
    label: FIELD_LABEL[field] || field,
    stored: v?.stored || "—",
    submitted: v?.submitted || "—",
  }));
}

/** Who sent the second version, in words. */
export function changeSource(change) {
  return change?.source === "operator" ? "completat telefonic de echipă" : "trimis de cursant";
}
